module.exports = __webpack_public_path__ + "static/media/game-settings-icon.2f28e49b.svg";